import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { AuthenticationService } from 'app/services';
import { forEach, find, head } from 'lodash';
import { UntypedFormControl } from '@angular/forms';
import { merge, Subject } from 'rxjs';
import { startWith, takeUntil, switchMap } from 'rxjs/operators';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BaseService } from 'app/_helpers/base/base.service';

@Component({
  selector: 'app-wg-activities-distribution',
  templateUrl: './wg-activities-distribution.component.html',
  styleUrls: ['./wg-activities-distribution.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgActivitiesDistributionComponent implements OnInit, OnDestroy, AfterViewChecked {

  //data
  widget = {
    type: 'line',
    datasets: [{ label: 'Meetings', data: [0], fill: 'start' }],
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    colors: [
      {
        borderColor: '#3949ab',
        backgroundColor: '#3949ab',
        pointBackgroundColor: '#3949ab',
        pointHoverBackgroundColor: '#3949ab',
        pointBorderColor: '#ffffff',
        pointHoverBorderColor: '#ffffff'
      },
      {
        borderColor: 'rgba(30, 136, 229, 0.87)',
        backgroundColor: 'rgba(30, 136, 229, 0.87)',
        pointBackgroundColor: 'rgba(30, 136, 229, 0.87)',
        pointHoverBackgroundColor: 'rgba(30, 136, 229, 0.87)',
        pointBorderColor: '#ffffff',
        pointHoverBorderColor: '#ffffff'
      }
    ],
    options: {
      spanGaps: false,
      legend: { display: false },
      maintainAspectRatio: false,
      tooltips: { position: 'nearest', mode: 'index', intersect: false },
      layout: { padding: { left: 24, right: 32 } },
      elements: { point: { radius: 4, borderWidth: 2, hoverRadius: 4, hoverBorderWidth: 2 } },
      scales: {
        x: { gridLines: { display: false }, ticks: { fontColor: 'rgba(0,0,0,0.54)' } },
        y: { gridLines: { tickMarkLength: 16 }, ticks: { stepSize: 10 }, beginAtZero: true}
      },
      plugins: { filler: { ropagate: false } }
    }
  } as any;

  user: any;
  activitiesSelectAll = false as boolean;
  activitiesUsersForm: UntypedFormControl = new UntypedFormControl([]);
  activitiesCheckBox = '' as any;
  activitiesFilter = {} as any;
  users: any;
  activitiesDataRange: UntypedFormControl = new UntypedFormControl('this_week');
  activitiesUserName = 'Users' as any;
  activitiesData: any = {};
  locale: string;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _authenticationService: AuthenticationService,
    public _translateService: TranslateService,
    private cdref: ChangeDetectorRef,
    private _gService: BaseService
  ) {
    this.locale = this._translateService.currentLang;
    this.user = this._authenticationService.currentUserValue;
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {

    this._translateService.onLangChange
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((langChangeEvent: LangChangeEvent) => {
        this.locale = langChangeEvent.lang;
        this.changeTranslations();
      });

    if (this.user.user_role !== 'agent') {
      // tslint:disable-next-line: prefer-const
      let search: any;
      this._gService.get(`users?user_name=${search}&support_user=${false}&per-page=${search}`).subscribe((data: any) => {
        this.users = data;
      });
    }

    merge(this.activitiesDataRange.valueChanges, this._translateService.onLangChange)
      .pipe(
        startWith('this_week'),
        takeUntil(this._unsubscribeAll),
        switchMap((range: string) => {
          return this._gService.post(`dashboard/activities_distribution?range=${this.activitiesDataRange.value}`, this.activitiesFilter, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        this.activitiesData = data;
        const day = new Date(this.activitiesData.firstDay);
        forEach(data.results, (value) => {
          value.label = value.label ? this._translateService.instant(value.label) : '';
        });
        this.widget.datasets = data.results;
        this.setDays(day.getDay() + 1);
      });

    this.activitiesUsersForm.valueChanges.subscribe(() => {
      if (this.activitiesUsersForm.value.length) {
        let user: any;
        user = head(this.activitiesUsersForm.value);
        user = find(this.users, ['_id', user]);
        this.activitiesUserName = user.username;
        this.activitiesFilter.users = this.activitiesUsersForm.value;
      } else {
        this.activitiesUserName = '';
        delete this.activitiesFilter.users;
      }
      this.activitiesDataRange.setValue(this.activitiesDataRange.value, { emitEvent: true });
    });

  }

  activitiesToggleAll(event: any): void {
    // tslint:disable-next-line: prefer-const
    let array = [];
    if (event.checked === true) {
      forEach(this.users, (value) => {
        array.push(value._id);
      });
      this.activitiesSelectAll = true;
      this.activitiesUsersForm.disable();
      this.activitiesCheckBox = array.length;
      this.activitiesFilter.users = array;
    } else {
      this.activitiesSelectAll = false;
      this.activitiesUsersForm.enable();
      this.activitiesCheckBox = '';
      this.activitiesFilter.users = this.activitiesUsersForm.value;
    }
    this.activitiesDataRange.setValue(this.activitiesDataRange.value, { emitEvent: true });
  }

  changeTranslations(): void {
    if (this.activitiesData && this.activitiesData.results) {
      this.activitiesData.results.forEach(element => {
        if (element.nameKey) {
          element.name = element.nameKey ? this._translateService.instant(element.nameKey) : '';
        }
      });
    }
    const results = this.activitiesData.results;
    this.activitiesData.results = [];
    setTimeout(() => {
      this.activitiesData.results = results;
    }, 50);
  }

  setDays(day: any): void {
    this.widget.labels = [];
    if (this.activitiesDataRange.value === 'this_week') {
      for (let i = 0; i < 7; i++) {
        this.widget.labels.push(this.getDays(day));
        if (day === 6) {
          day = 0;
        } else {
          day++;
        }
      }
    } else if (this.activitiesDataRange.value === 'today') {
      this.widget.labels.push(this._translateService.instant('today'));
    } else if (this.activitiesDataRange.value === 'tomorrow') {
      this.widget.labels.push(this._translateService.instant('tomorrow'));
    } else if (this.activitiesDataRange.value === 'this_month') {
      this.widget.labels.push(this._translateService.instant('week_1'),
        this._translateService.instant('week_2'), this._translateService.instant('week_3'),
        this._translateService.instant('week_4'));
    }
  }

  getDays(day: any): any {
    switch (day) {
      case 1: {
        return this._translateService.instant('Sun');
        break;
      }
      case 2: {
        return this._translateService.instant('Mon');
        break;
      }
      case 3: {
        return this._translateService.instant('Tue');
        break;
      }
      case 4: {
        return this._translateService.instant('Wed');
        break;
      }
      case 5: {
        return this._translateService.instant('Thu');
        break;
      }
      case 6: {
        return this._translateService.instant('Fri');
        break;
      }
      case 0: {
        return this._translateService.instant('Sat');
        break;
      }
      default: {
        return null;
        break;
      }
    }
  }

  ngAfterViewChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

}
